import AntdButton from './AntdButton';
import YsdButton from './Button';
import ButtonGroup from './ButtonGroup';
const Button = YsdButton;
Button.Group = ButtonGroup;
Button.__ANT_BUTTON = AntdButton.__ANT_BUTTON;
export default Button;
